<div class="timer-container">
    <div *ngIf="editMode; else countdownmode" class="time-input d-flex justify-content-around">
        <div class="time-input-group">
            <label *ngIf="editMode" for="hours">Hours:</label>
            <div class="input-with-buttons">
                <button type="button" *ngIf="editMode" (click)="decrementHours()" class="time-button">-</button>
                <input type="number" [disabled]="!editMode" id="hours" min="0" [(ngModel)]="hours" (change)="updateTotalSeconds()">
                <button type="button" *ngIf="editMode" (click)="incrementHours()" class="time-button">+</button>
            </div>
        </div>
    
        <div class="time-input-group">
            <label *ngIf="editMode" for="minutes">Minutes:</label>
            <div class="input-with-buttons">
                <button type="button" *ngIf="editMode" (click)="decrementMinutes()" class="time-button">-</button>
                <input type="number" [disabled]="!editMode" id="minutes" max="59" [(ngModel)]="minutes" (change)="updateTotalSeconds()">
                <button type="button" *ngIf="editMode" (click)="incrementMinutes()" class="time-button">+</button>
            </div>
        </div>
    </div>
    <ng-template #countdownmode>            
        <span *ngIf=" (this.hours * 3600) + (this.minutes * 60) + (this.seconds) > 0 && hasTimerStarted">{{ remainingTime }}</span>
    </ng-template>
</div>
